export const customDateRangeFlag = 'CUSTOM_FILTER_VALUE';

export const quickDateRange = {
  value: customDateRangeFlag,
  text: 'Custom',
};
